module.exports = __webpack_public_path__ + "static/media/mitarbeiter_all_true_active.07b8583c.jpg";